import React from "react"
import { Helmet } from "react-helmet"
import InterUrl from "../fonts/Inter.var.woff2"
import InterRomanUrl from "../fonts/Inter-roman.var.woff2"
import InterItalicUrl from "../fonts/Inter-italic.var.woff2"

interface DocumentHeadProps {
  title: string
  description: string
  logo?: string
}

export const DocumentHead = ({
  title,
  description,
  logo,
}: DocumentHeadProps) => (
  <Helmet title={title}>
    <meta name="description" content={description} />
    {logo && <meta name="image" content={logo} />}
    <link
      rel="preload"
      as="font"
      href={InterUrl}
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href={InterRomanUrl}
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href={InterItalicUrl}
      type="font/woff2"
      crossOrigin="anonymous"
    />
  </Helmet>
)
